<template>
  <div id="_2026_1">
    <div id="Call-for-Nominations">
      <h3>
        <strong class="home-h">
          Call for Nominations - IGU Outstanding Achievement Award and
          Excellent Young Scholar Award in Modeling Geographical Systems (2026)
        </strong>
      </h3>
      <hr />
      <p>
        The
        <strong>
          IGU Outstanding Achievement Award and Excellent Young Scholar Award
          in Modeling Geographical Systems (OAA 2026 and YSA 2026)
        </strong>
        are receiving nominations to recognize researchers for long and
        meritorious contributions to the community of geographic modeling
        research or young researchers for meritorious academic contributions
        in their early career. An awards committee will be organized by IGU
        through its Modeling Geographical Systems Commission (IGU MGSC), and it
        will solicit and evaluate the nominees and present the awards to the
        individuals in light of their excellent scientific achievements and
        contributions.
      </p>

      <h5>Eligibility</h5>
      <ul>
        <li>
          Nominees for the OAA 2026 are expected to have outstanding research
          contributions to geographic modeling and relevant fields.
        </li>
        <li>
          Nominees for the YSA 2026 should have received a doctoral degree in
          the last seven years (no earlier than 2018) and have significant
          research contributions to geographic modeling and relevant fields.
        </li>
        <li>Nominees for the YSA 2026 also should be IGU MGSC members.</li>
      </ul>

      <h5>Award Benefits</h5>
      <p>
        The award committee will select one awardee for OAA 2026, and the
        awardee will receive an award certificate and cash prizes (USD $500).
      </p>
      <p>
        The award committee will select two awardees for YSA 2026, and each
        awardee will receive an award certificate and cash prizes (USD $300).
      </p>

      <h5>Submission Instructions</h5>
      <p>
        To nominate an award for OAA 2026, please submit the following documents
        as PDF files:
      </p>
      <ul>
        <li>
          <strong>Nomination Letter</strong>: A personal statement is needed to
          describe the nominee’s contributions and achievements. The statement
          should be no more than 500 words.
        </li>
        <li>
          <strong>Curriculum Vitae or Resume</strong>: The latest curriculum
          vitae or resume of nominees.
        </li>
      </ul>
      <p>
        To nominate an award for YSA 2026, please submit the following documents
        as PDF files:
      </p>
      <ul>
        <li>
          <strong>Nomination Letter</strong>: A personal statement is needed to
          describe the nominee’s contributions and achievements. The statement
          should be no more than 500 words.
        </li>
        <li>
          <strong>Curriculum Vitae or Resume</strong>: The latest curriculum
          vitae or resume of nominees.
        </li>
        <li>
          <strong>Certificate of Academic Degree</strong>: The certificate can
          prove the eligibility of nominees.
        </li>
        <li>
          <strong>Two Recommendation Letter</strong>: The recommender must have
          a formal professional role that allows them to assess the nominee’s
          achievements, current academic status and progress. The recommendation
          letter should be signed by the recommenders. Once prepared, the letter
          should be converted to a PDF format.
        </li>
      </ul>

      <p>
        The Nomination Letter Template can be found under the “Awards” page of
        the official website of IGU MGSC
        (<a href="http://www.igu-geomodeling.com/Awards">http://www.igu-geomodeling.com/Awards</a>).
      </p>
      <p>
        Nominators or nominees need to merge the mentioned documents into a
        single PDF file. Please submit the PDF file to Secretary General of
        MGSC, Prof. Wei Luo (<a href="mailto:geowl@nus.edu.sg">geowl@nus.edu.sg</a>),
        and cc to Dr. Zaiyang Ma
        (<a href="mailto:mazaiyang@njnu.edu.cn">mazaiyang@njnu.edu.cn</a>),
        including “IGU MGSC Outstanding Achievement Award” or “IGU MGSC
        Excellent Young Scholar Award” in the email subject line.
        (<strong>Self-nominations are not accepted.</strong>)
      </p>

      <h5>Important date</h5>
      <p>The tentative dates for submission and notifications are as follows.</p>
      <ul>
        <li>Deadline for submission: October 15, 2026</li>
        <li>Deadline for notification to the awardee: November 15, 2026</li>
      </ul>

      <h5>Contact</h5>
      <p>
        Prof. Wei Luo: <a href="mailto:geowl@nus.edu.sg">geowl@nus.edu.sg</a><br />
        Dr. Zaiyang Ma:
        <a href="mailto:mazaiyang@njnu.edu.cn">mazaiyang@njnu.edu.cn</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2026_1'
};
</script>

<style scoped lang="less">
#_2026_1 {
  height: fit-content;
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 2.2rem auto 0;
  position: relative;
  word-spacing: 0.3rem;
  text-align: justify;
}

h3 {
  color: #1a80b6;
  font-size: 1.3rem;
  font-weight: 1000;
}

h5 {
  font-weight: bold;
}

a {
  text-decoration: none;
}
</style>
